module.exports = __webpack_public_path__ + "static/img/guid.77e0c0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/guid.png
// module id = Wrse
// module chunks = 1